@defer (when isLoaded && centerOnCountry) {
  @if (isLoaded && centerOnCountry) {
    <sd-store-locator
      [title]="title"
      [isPickup]="isPickup"
      [mapLegend]="mapLegend"
      [centerOnCountry]="centerOnCountry"
      [stores]="filteredStores"
      [isEmbedded]="isEmbedded"
      [isCheckout]="isCheckout"
      [bounds]="bounds"
      [product]="product"
      [filters]="filters"
      [isHob]="isHobSignal()"
      [repairCenter]="isRepair && !hideChooseButton"
      [hideCardActions]="hideCardActions"
      (locate)="onLocate($event)"
      (storeFiltered)="updateFilters($event)"
      [searchCountryRestrictions]="searchCountryRestrictions"
      [hasNoResults]="hasNoResults"
      (productClicked)="onProductClick($event)"
      (chooseSelected)="selectRepairer($event)"
      (learnMoreClicked)="onLearnMoreClick($event)"
      (itenaryClicked)="onItenaryClick($event)"
    />
  }
}
